<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button v-if="$checkBtnPermission('/order/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button v-if="$checkBtnPermission('/order/index', 'reset')" size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions></template>
			<el-form-item label="订单编号：">
					<el-input clearable v-model="formInline.orderNo" size="small" placeholder="请输入订单编号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="所属门店：">
					<el-select filterable v-model="formInline.belongStoreKeyId" placeholder="请选择门店" clearable size="small" @change="getListData">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="快递时间：">
					<el-date-picker
						v-model="dateValue"
						clearable
						size="small"
						type="daterange"
						value-format="yyyy-MM-dd"
						format="yyyy-MM-dd"
						range-separator="~"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						@change="handleDateChange"
					></el-date-picker>
				</el-form-item>
			</lcsj-filter>
			<STable :columns="columnsData" :data="listData" :loading="loading" border @get-data="getListData">
				<el-table-column slot="customerInfo.gender" align="center" label="性别" width="80">
					<template #default="scope">
						{{ scope.row.customerInfo.gender === 1 ? "男" : "女" }}
					</template>
				</el-table-column>
				<template #mdKDNo>
					<el-table-column label="门店快递单号" width="180">
						<template #default="scope">
							<el-link v-if="scope.row.storeKDNo" type="primary" size="small" @click="openNewWindowSearchKuaiDi(scope.row.storeKDNo)">
								{{ scope.row.storeKDNo }}
							</el-link>
							<span v-else>
								{{ scope.row.storeKDNo }}
							</span>
						</template>
					</el-table-column>
				</template>
				<template #jgbkdNo>
					<el-table-column label="加工部快递单号" width="180" align="center">
						<template #default="scope">
							<el-link v-if="scope.row.jgbkdNo" type="primary" size="small" @click="openNewWindowSearchKuaiDi(scope.row.jgbkdNo)">
								{{ scope.row.jgbkdNo }}
							</el-link>
							<span v-else>
								{{ scope.row.jgbkdNo }}
							</span>
						</template>
					</el-table-column>
				</template>
				<template #actionHandle>
					<el-table-column v-if="btnPermission.delete" align="center" label="操作" width="200" fixed="right">
						<template #default="scope">
							<el-button v-if="btnPermission.delete && scope.row.state === 1" size="small" type="danger" class="el-icon-delete" @click="handleDeleteOrder(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
	</div>
</template>

<script>
import { GetJGBKDList, DeleteStoreOrder } from "@/api/storeOrderApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "快递信息列表"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			selectionList: [],
			selectionRowKeyIds: [],
			dateValue: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				customerPhone: "",
				customerName: "",
				belongStoreKeyId: "",
				orderNo: "",
				storeKDNo: "",
				jgbkdNo: "",
				startTime: null,
				endTime: null
			},
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "keyId",
					label: "全选",
					align: "center",
					width: "55",
					isKeep: true,
					selection: true
				},
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					isKeep: true,
					width: "80"
				},
				{
					prop: "createTime",
					label: "录入时间",
					width: "160",
					isKeep: true,
					align: "center",
				},
				{
					prop: "belongStoreName",
					label: "所属门店",
					isKeep: true,
					width: "150",
					align: "center"
				},
				{
					prop: "customerInfo.name",
					label: "顾客姓名",
					width: "100",
					align: "center",
				},
				{
					prop: "orderNo",
					label: "订单编号",
					isKeep: true,
					width: "230",
					align: "center"
				},
				{
					prop: "getOrderDate",
					label: "取镜时间",
					width: "100",
					align: "center"
				},
				{
					prop: "customerInfo.phone",
					label: "顾客电话",
					width: "130",
					align: "center"
				},
				{
					slot: "customerInfo.gender",
					label: "性别",
					width: "80",
					align: "center"
				},
				{
					prop: "customerInfo.age",
					label: "年龄",
					width: "80",
					align: "center"
				},
				{
					prop: "orderDate",
					label: "下单日期",
					width: "100",
					align: "center"
				},
				// {
				//   slot: "storeKDNo",
				//   label: "门店快递订单号",
				//   width: "220",
				// },
				{
					slot: "jgbkdNo",
					label: "加工部快递订单号",
					width: "220"
				},
				{
					prop: "creator",
					label: "录入人",
					width: "100"
				},
				{
					prop: "content",
					label: "内容",
					width: "160"
				},
				{
					slot: "actionHandle",
					label: "操作",
					width: "160",
					align: "center",
					fixed: "right"
				}
			],
			chooseTime: "",
			storeList: [],
			stateList: [],
			orderSourceList: [],
			dialogVisible: false,
			kdNo: "",
			// 按钮权限
			btnPermission: {
				delete: false
			},
			createOrEdit: 1, //1新增2修改
			delayDays: 1
		};
	},
	// 注册组件
	components: {},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetOrgInfoListByConfig();
		// 按钮权限
		this.getBtnPermission();
	},
	computed: {},
	methods: {
		openNewWindowSearchKuaiDi(value) {
			if (value && value.startsWith("SF")) {
				window.open("https://www.sf-express.com/chn/sc/waybill/waybill-detail/" + encodeURIComponent(value));
			} else {
				this.$message.error("不是顺丰单号，不支持快递信息查询！");
			}
		},
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		handleDateChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
			this.getListData();
		},
		changePages() {},
		handleCommand(command) {
			// 1编辑
			switch (command.command) {
				case "4":
					this.handleDeleteOrder(command.rowData);
					break;
				default:
					console.log(command);
			}
		},
		//显示新增界面
		handleEdit() {
			this.createOrEdit = 1;
			this.$refs.create.showCreateDialog();
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetJGBKDList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 查看详情
		handleSeeDetail(row) {
			this.$refs.storeDetail.showSeeDetailDialog(row);
		},
		// 删除订单
		handleDeleteOrder(row) {
			this.$confirm("确定删除订单【" + row.orderNo + "】吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					let params = {
						keyId: row.keyId
					};
					DeleteStoreOrder(params).then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "订单删除成功！"
							});
							this.getListData();
						} else {
							this.$message.error(res.msg);
						}
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除订单"
					});
				});
		},
		// 按钮权限
		getBtnPermission() {
			this.btnPermission.delete = this.$checkBtnPermission("/order/index", "delete");
		}
	}
};
</script>

<style scoped>

</style>
